module.exports = __webpack_public_path__ + "static/media/gardening.88b108e3.png";